import { gql } from '@apollo/client';

export const CREATE_DATA_IMPORTER = gql`
    mutation CreateDataImporter($input: CreateDataImporterInput!) {
        facility {
            configurations {
                dataImporters {
                    createImporter(input: $input) {
                        id
                        name
                        type
                        description
                        isRestricted
                        configuration
                        state
                        isStateful
                    }
                }
            }
        }
    }
`;
